import { i18n } from '@/plugins/i18n'
import { InvoiceStatus } from '@/constants'
import { invertKeyValues } from '@/common/objects'

export const invoiceStatusStr = (status) => {
    const statusStr = invertKeyValues(InvoiceStatus)[status]

    return statusStr ? i18n.t(`invoice.statuses.${statusStr.toLowerCase()}`) : 'undefined'
}